import * as React from "react"
import { graphql } from "gatsby"
import * as styles from "./Break.css"

export type BreakProps = {
  link: string
  text: string
  newWindow: boolean
}

export default function BreakComponent(props: BreakProps) {
  return <div className={styles.Break}></div>
}

export const query = graphql`
  fragment BreakContent on Break {
    id
  }
`

